export const payload = {
  receiveMutation: 'RECEIVE_ASSETS',
  receivingMutation: 'RECEIVING_ASSETS',
  receiveMetadataMutation: 'RECEIVE_ASSET_METADATA',
  receiveFailureMutation: 'RECEIVE_ASSET_FAILURE',
  savingMutation: 'SAVING_ASSET',
  saveFailureMutation: 'SAVING_ASSET_FAILURE',
  incrementMutation: 'INCREMENT_ASSET_COUNT',
  updatingMutation: 'UPDATING_ASSET',
  updateFailureMutation: 'UPDATING_ASSET_FAILURE',
  deleteMutation: 'DELETE_ASSET',
  deletingMutation: 'DELETING_ASSET',
  deleteFailureMutation: 'DELETING_ASSET_FAILURE',
  resetMetaMutation: 'RESET_ASSET_META',
  clearMutation: 'CLEAR_ASSET_STATE',
  moduleName: 'asset',
  endpoint: 'assets'
}
